// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c53f6f3c","952":"b03bc4d6"}[chunkId] + ".chunk.js";
};